import React from 'react';
import { Card, CardContent, Typography, Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: (theme.shape.borderRadius as number) * 2,
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: theme.shadows[4]
  }
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: 64,
  height: 64,
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  color: 'white',
  fontSize: 28
}));

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  gradient?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description, gradient }) => {
  return (
    <StyledCard>
      <CardContent sx={{ p: 4 }}>
        <Stack spacing={2}>
          <IconContainer sx={{ background: gradient || undefined }}>
            {icon}
          </IconContainer>
          
          <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary' }}>
            {title}
          </Typography>
          
          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
            {description}
          </Typography>
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export default FeatureCard;